<template>
  <div>
    <HeroImageOrVideo v-if="imageSrc" :image="imageSrc">
      <div class="container flex items-center h-full flex-wrap">
        <BarText :text="entry.textOverlay" tag="h1" class="fluid-4xl leading-none" />
      </div>
    </HeroImageOrVideo>
    <StoriesPageBlocks :blocks="entry.storiesPageBlocks" :social-media-accounts="socialMediaAccounts" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import HeroImageOrVideo from '@/components/common/HeroImageOrVideo';
import BarText from '@/components/BarText.vue';

import StoriesPageBlocks, { StoriesPageBlocksMatrixFragment } from '@/components/stories/StoriesPageBlocks';

export const StoriesHomePageFragment = gql`
  fragment StoriesHomePageFragment on storiesHome_Entry {
    title
    textOverlay
    seoTopics
    headerImageOrVideo {
      url
      kind
    }
    storiesPageBlocks {
      ...StoriesPageBlocksMatrixFragment
    }
  }
  ${StoriesPageBlocksMatrixFragment}
`;

export default {
  name: 'StoriesHomePage',
  components: { HeroImageOrVideo, BarText, StoriesPageBlocks },
  props: {
    entry: {
      type: Object,
      default: () => {},
    },
    socialMediaAccounts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    imageSrc() {
      return this.entry?.headerImageOrVideo?.length ? this.entry?.headerImageOrVideo[0] : null;
    },
  },
};
</script>
